var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isBlank)?_c('el-card',{attrs:{"body-style":{padding: '20px',height: '100%',boxSizing: 'border-box', textAlign: 'left'}}},[_c('router-view')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }